import { errorMessage } from '../api/client';
import { cn } from '../lib/cn';
import { Button } from './Button';

export function ErrorBanner({ error, onRetry, className }: { error: unknown; onRetry?: () => void; className?: string }) {
  if (!error) return null;
  return (
    <div role="alert" className={cn('flex items-start justify-between gap-3 rounded-md border border-danger/30 bg-danger-soft px-3 py-2 text-sm text-danger', className)}>
      <span>{errorMessage(error)}</span>
      {onRetry && (
        <Button size="sm" variant="ghost" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}
